import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import Reference from '../Reference';
import TradedAmount from '../TradedAmount';
import ConvertedAmount from '../ConvertedAmount';

import styles from './index.module.css';

const MobileColumn1 = ({ value }) => {
  const status = value.get('status');
  const reference = value.get('reference');
  const tradedAmount = value.get('tradedAmount');
  const convertedAmount = value.get('convertedAmount');

  return (
    <div className={styles.root}>
      {status !== 'completed' ? (
        <>
          <div className={styles.top}>
            <Reference value={reference} />
          </div>
          <div className={styles.bottom}>
            <ConvertedAmount value={convertedAmount} />
          </div>
        </>
      ) : (
        <>
          <div className={styles.top}>
            <TradedAmount value={tradedAmount} />
          </div>
          <div className={styles.bottom}>
            <ConvertedAmount value={convertedAmount} />
          </div>
        </>
      )}
    </div>
  );
};

MobileColumn1.propTypes = {
  value: PropTypes.instanceOf(Map).isRequired,
};

export default MobileColumn1;
